import Vue from 'vue';

import moment from 'moment-timezone';
import 'moment/locale/fr-ca';

moment.locale('fr-ca');

Vue.filter('money', function(value) {
  return parseFloat(value).toFixed(2).replace('.', ',') + ' $';
});

Vue.filter('formatDate', function(value) {
  if (_.isString(value)) {
    return moment.tz(value.substring(0, value.length - 5), 'UTC').tz('America/New_York').format('D MMM YYYY');
  }
});

Vue.filter('formatDateFormat', function(value, format) {
  if (_.isString(value)) {
    return moment(value, format).format('D MMM YYYY');
  }
});

Vue.filter('formatFullDate', function(value) {
  return moment.tz(value.substring(0, value.length - 5), 'UTC').tz('America/New_York').format('Do MMMM YYYY');
});

Vue.filter('formatDateAndTime', function(value) {
  if (_.isNumber(value)) {
    return moment.tz(moment.unix(value), 'UTC').tz('America/New_York').format('D MMM YYYY HH:mm');
  }
  else {
    return moment.tz(value.substring(0, value.length - 5), 'UTC').tz('America/New_York').format('D MMM YYYY HH:mm');
  }
});

Vue.filter('formatMoney', function(v) {
  if (v === null) {
    return 'Non spécifié';
  }
  return v.toFixed(2) + ' $';
});
